import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormButton } from "@/forms-design-system/FormButton";
import { ChevronLeft, ChevronRight } from "@/icons/outlined";

interface PrizeScrollButtonProps {
  direction: "previous" | "next";
  onClick: () => void;
}

export const PrizeScrollButton: FC<PrizeScrollButtonProps> = ({ direction, onClick }) => {
  const { t } = useTranslate();
  const isNext = direction === "next";

  return (
    <FormButton
      variant="rounded"
      size="large"
      iconButton
      startIcon={isNext ? <ChevronRight /> : <ChevronLeft />}
      onClick={onClick}
      aria-label={t("ticketing", isNext ? "prizes.nextPrize" : "prizes.previousPrize")}
      data-test={`prizes-scroll-${direction}`}
      sx={(theme) => ({
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1,
        backgroundColor: theme.palette.forms.surface.intense,
        borderColor: theme.palette.forms.border.brand,
        color:
          theme.palette.metadata?.mode === "dark" ? theme.palette.forms.text.intense : theme.palette.forms.text.reverse,
        ...(isNext ? { right: theme.spacing(3) } : { left: theme.spacing(1) }),
      })}
    />
  );
};
